import React from "react";

import { CardRoot } from "./styles";

interface HeaderCardsProps {
  children: React.ReactNode;
}

export const HeaderCards = ({ children }: HeaderCardsProps) => {
  return <CardRoot>{children}</CardRoot>;
};
